import { Button, Skeleton, Stack, Typography } from '@mui/material';
import useLocalization from '../../../hooks/useLocalization';

type FinpspPaymentLoadingProps = {
  isError: boolean;
  onRetry: () => void;
};

const styles = {
  root: {
    gap: 2,
  },
};

const FinpspPaymentLoading = ({ isError, onRetry }: FinpspPaymentLoadingProps) => {
  const { t } = useLocalization();

  return (
    <Stack direction='column' sx={styles.root}>
      {isError ? (
        <>
          <Typography variant='body2'>{t('finpspStatusUnavailable')}</Typography>
          <Button variant='text' onClick={onRetry}>
            {t('retry')}
          </Button>
        </>
      ) : (
        <Skeleton variant='rounded' height={120} />
      )}
    </Stack>
  );
};

export default FinpspPaymentLoading;
